// product-recommendation-dgs and vendor-catalog-dgs

export var UserSubscriptionAction = /*#__PURE__*/function (UserSubscriptionAction) {
  UserSubscriptionAction["JOIN"] = "JOIN";
  UserSubscriptionAction["RESUBSCRIBE"] = "RESUBSCRIBE";
  UserSubscriptionAction["RESUME"] = "RESUME";
  UserSubscriptionAction["REVOKE_PENDING_CANCEL"] = "REVOKE_PENDING_CANCEL";
  UserSubscriptionAction["REVOKE_PENDING_PAUSE"] = "REVOKE_PENDING_PAUSE";
  UserSubscriptionAction["UPGRADE"] = "UPGRADE";
  UserSubscriptionAction["DOWNGRADE"] = "DOWNGRADE";
  return UserSubscriptionAction;
}({});
export var PlanState = /*#__PURE__*/function (PlanState) {
  PlanState["ACTIVE"] = "ACTIVE";
  PlanState["INACTIVE"] = "INACTIVE";
  return PlanState;
}({});

// subscription-dgs

export var SubscriberState = /*#__PURE__*/function (SubscriberState) {
  SubscriberState["NEW_SUBSCRIBER"] = "NEW_SUBSCRIBER";
  SubscriberState["RETURNING_SUBSCRIBER"] = "RETURNING_SUBSCRIBER";
  return SubscriberState;
}({});
export var SubscriptionState = /*#__PURE__*/function (SubscriptionState) {
  SubscriptionState["ACTIVE"] = "ACTIVE";
  SubscriptionState["CANCELLED"] = "CANCELLED";
  SubscriptionState["EXPIRED"] = "EXPIRED";
  SubscriptionState["PAUSED"] = "PAUSED";
  return SubscriptionState;
}({});
export var MyLatestSubscriptionStatus = /*#__PURE__*/function (MyLatestSubscriptionStatus) {
  MyLatestSubscriptionStatus["ACTIVE"] = "ACTIVE";
  MyLatestSubscriptionStatus["ACTIVE_END_OF_BILLING_CYCLE"] = "ACTIVE_END_OF_BILLING_CYCLE";
  MyLatestSubscriptionStatus["CANCELLED"] = "CANCELLED";
  MyLatestSubscriptionStatus["PAUSED_NO_ACCESS"] = "PAUSED_NO_ACCESS";
  return MyLatestSubscriptionStatus;
}({});
export var SubscriptionType = /*#__PURE__*/function (SubscriptionType) {
  SubscriptionType["ONE_TIME"] = "ONE_TIME";
  SubscriptionType["RECURRING"] = "RECURRING";
  return SubscriptionType;
}({});
export var VendorType = /*#__PURE__*/function (VendorType) {
  VendorType["CHEGG"] = "CHEGG";
  VendorType["RECURLY"] = "RECURLY";
  return VendorType;
}({});
export var SubscriptionPlatform = /*#__PURE__*/function (SubscriptionPlatform) {
  SubscriptionPlatform["ANDROID"] = "ANDROID";
  SubscriptionPlatform["IOS"] = "IOS";
  SubscriptionPlatform["WEB"] = "WEB";
  return SubscriptionPlatform;
}({});
export var ProductFamilyType = /*#__PURE__*/function (ProductFamilyType) {
  ProductFamilyType["CHEGG_MATH"] = "chegg_math";
  ProductFamilyType["CHEGG_STUDY"] = "chegg_study";
  ProductFamilyType["CHEGG_STUDY_PACK"] = "chegg_study_pack";
  ProductFamilyType["CHEGG_WRITING"] = "chegg_writing";
  ProductFamilyType["EASYBIB"] = "easybib";
  ProductFamilyType["BIBME"] = "bibme";
  ProductFamilyType["CTFM"] = "ctfm";
  ProductFamilyType["CITATIONMACHINE"] = "citationmachine";
  return ProductFamilyType;
}({});
export var PRSProductFamilyTypeInput = /*#__PURE__*/function (PRSProductFamilyTypeInput) {
  PRSProductFamilyTypeInput["CHEGG_MATH"] = "CHEGG_MATH";
  PRSProductFamilyTypeInput["CHEGG_STUDY"] = "CHEGG_STUDY";
  PRSProductFamilyTypeInput["CHEGG_STUDY_PACK"] = "CHEGG_STUDY_PACK";
  PRSProductFamilyTypeInput["CHEGG_WRITING"] = "CHEGG_WRITING";
  return PRSProductFamilyTypeInput;
}({});
export var DiscountType = /*#__PURE__*/function (DiscountType) {
  DiscountType["FIXED"] = "FIXED";
  DiscountType["PERCENT"] = "PERCENT";
  return DiscountType;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/product-recommendation-dgs.types.js
// module id = 1403
// module chunks = 11